import { useState, useEffect } from 'react'
import { doc, getDoc, setDoc } from 'firebase/firestore'
import { db } from '../firebase'

export function useUserSettings(user) {
  const [defaultTreeRoot, setDefaultTreeRootState] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!user) {
      setLoading(false)
      return
    }

    const fetchSettings = async () => {
      try {
        const settingsRef = doc(db, 'userSettings', user.uid)
        const settingsDoc = await getDoc(settingsRef)
        
        if (settingsDoc.exists()) {
          setDefaultTreeRootState(settingsDoc.data().defaultTreeRoot || null)
        }
      } catch (err) {
        console.error('Error fetching user settings:', err)
      } finally {
        setLoading(false)
      }
    }

    fetchSettings()
  }, [user])

  const setDefaultTreeRoot = async (personId) => {
    if (!user) return

    try {
      const settingsRef = doc(db, 'userSettings', user.uid)
      await setDoc(settingsRef, { defaultTreeRoot: personId }, { merge: true })
      setDefaultTreeRootState(personId)
      return true
    } catch (err) {
      console.error('Error setting default tree root:', err)
      throw err
    }
  }

  return {
    defaultTreeRoot,
    setDefaultTreeRoot,
    loading
  }
}
